import ctl from '@netlify/classnames-template-literals'
import { TransformerGizmoRotate } from './gizmo-rotate'
import { TransformerGizmoScale } from './gizmo-scale'
import { BoundingBox } from './math'
import { Size, TransformerState } from './state'

export function TransformerGizmoCorner({
	transformedRef,
	boundingBox,
	state,
	position,
	originalSize,
	enableScaling = true,
}: {
	transformedRef: React.RefObject<HTMLDivElement | null>
	boundingBox: BoundingBox
	state: TransformerState
	originalSize: Size
	position: 'topLeft' | 'topRight' | 'bottomLeft' | 'bottomRight'
	enableScaling?: boolean
}) {
	const oppositePosition = ({
		topLeft: 'bottomRight',
		topRight: 'bottomLeft',
		bottomLeft: 'topRight',
		bottomRight: 'topLeft',
	} as const)[position]

	return (
		<div
			className="absolute pointer-events-auto"
			style={{
				transform: `translate(${boundingBox[position].x}px, ${boundingBox[position].y}px)`,
			}}
			data-prevent-focus-loss
		>
			<div
				className="relative size-6"
				style={{
					transform: `translate(-50%, -50%) rotate(${state.rotation}rad)`,
				}}
			>
				{enableScaling && (
					<div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
						<TransformerGizmoScale
							transformedRef={transformedRef}
							originalSize={originalSize}
							startBoundingBox={boundingBox}
							anchor={oppositePosition}
						/>
					</div>
				)}
				<div
					className={ctl(
						`absolute rotate-45
                        ${position === 'topLeft' && '-top-2 -left-2'}
                        ${position === 'topRight' && '-top-2 -right-2'}
                        ${position === 'bottomLeft' && '-bottom-2 -left-2'}
                        ${position === 'bottomRight' && '-bottom-2 -right-2'}
                        `,
					)}
				>
					<TransformerGizmoRotate
						transformedRef={transformedRef}
					/>
				</div>
			</div>
		</div>
	)
}
